import { EProjectSection, trackEventV2 } from '../trackEventV2';
import { RenterDashboardEventName, TDriverVerificationEvent } from './types';

export const trackVerification = (
  event: TDriverVerificationEvent,
  eventName: RenterDashboardEventName,
) => {
  trackEventV2(eventName, EProjectSection.MARKETPLACE, event);
};
